export const SPONSOR_UTM_SOURCE = 'giochini-di-parole';

export const addUtmSource = (url, source = SPONSOR_UTM_SOURCE) => {
  if (!url || typeof url !== 'string') return '';
  if (!source || typeof source !== 'string') return url;

  try {
    const parsed = new URL(url);
    parsed.searchParams.set('utm_source', source);
    return parsed.toString();
  } catch (_) {
    return url;
  }
};
